export default "__VITE_ASSET__BUuMyT0u__"